// Original source: /Users/matteo/projects/vareselab/backend/src/shared/membership.ts
export enum MembershipStatus {
    active = 'active',
    inactive = 'inactive',
}

export enum MembershipType {
    recurring = 'recurring',
    carnet = 'carnet',
}

export interface Membership {
    status: MembershipStatus;
    start_date: string | null;
    end_date: string | null;
    slots_per_week: number | null;
    type: MembershipType | null;
    carnet_total_slots: number | null;
    carnet_remaining_slots: number | null;
}